<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    :footer="false"
    size="normal"
    :loading="importHandleLoading"
    :loading-text="importHandleLoadingText"
  >
    <template #header>
      <span>导入关联产品</span>
    </template>
    <template #content>
      <div v-loading="loading">
        <gj-upload
          class="upload-btn"
          :template-url="'/operation/listing/exportProductLinkTemplate'"
          container-type="listingRelateProduct"
          @uploadAfter="importRelateProduct"
        >
          <template #tip>
            <span>只能上传xls/xlsx文件</span>
          </template>
        </gj-upload>
        <gj-import-alert
          :rules="[
            '模板中的表头不可更改，不能删除',
            'MSKU和SKU对应关系多条时，以最后一条记录为准',
            '导入已配对MSKU和SKU的对应关系，会更新原来的对应关系',
            '文件大小不可超过20M',
          ]"
        >
        </gj-import-alert>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, uploadMixin } from '../../../../../minxins';
import { importRelateProduct } from '../../../../../api/sale';

export default {
  name: 'app-import-relate-product-modal',
  mixins: [modalMixIn, uploadMixin],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    importRelateProduct(attId, data, uploadCb) {
      this.importHandleLoading = true;
      importRelateProduct(attId)
        .then((res) => {
          this.$gjImportHandle(res, uploadCb);
        })
        .catch(() => {
          uploadCb('error');
        })
        .complete(() => (this.importHandleLoading = false));
    },
  },
};
</script>

<style scoped>
.checkbox {
  margin: 8px 0;
}
.upload-btn {
  margin-bottom: 16px;
}
/*/deep/ .gj-modal--custom .el-dialog {*/
/*  width: 700px !important;*/
/*}*/
</style>
